import styled from 'styled-components';

export const TabsContainer = styled.div<{ isBrazeSnackbar: boolean }>`
    position: relative;
    z-index: -1;
    .transition__group {
        position: absolute;
        right: 0;
        left: 0;
    }
    .flash_messages,
    .notifications {
        position: absolute;
        top: 0px;
    }
    .tabs__wrapper {
        background: ${p =>
            p.isBrazeSnackbar ? 'rgba(255, 255, 255, 0.0)' : 'rgba(255, 255, 255, 0.9)'};
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
        width: 100%;
        padding: 0;
        .grid-row {
            max-width: 1208px;
            margin: 0 auto;
            padding-left: 20px;
            font-family: 'Helvetica Now Text', sans-serif;
            button span {
                text-transform: uppercase;
            }
            button[aria-selected='true'] {
                border-bottom: 2px solid #000;
                span {
                    font-weight: 700;
                }
            }
        }
    }
`;

export const HeaderWrap = styled.div<{ movePostionTopBy: number }>`
    position: sticky;
    top: ${({ movePostionTopBy }) => `${movePostionTopBy}px`};
    width: 100%;
    z-index: 3000;
    box-sizing: content-box;
`;

export const HeaderRowsHolder = styled.div`
    display: flex;
    flex-direction: column;
`;

export const HeaderBannerRow = styled.div<{ height?: number | 'auto' }>`
    height: ${({ height = 60 }) => (height === 'auto' ? 'auto' : `${height}px`)};
    transform: translate(0, 0);
    .flash_messages {
        position: static;
    }
`;
